import { createAsyncAction } from 'typesafe-actions';

import { PermissionItem, RolePermissionItem, UserRoleItem } from './types';

export type GetUserRolesSuccessPayload = {
  data: UserRoleItem[];
};

export const getUserRoles = createAsyncAction(
  'userRole/getUserRoles/request',
  'userRole/getUserRoles/success',
  'userRole/getUserRoles/failure',
)<void, GetUserRolesSuccessPayload, undefined>();

export type FetchRolePermissionsRequestPayload = {
  roleId: string;
};

export type FetchRolePermissionsSuccessPayload = {
  data: RolePermissionItem[];
};

export const fetchRolePermissions = createAsyncAction(
  'userRole/fetchRolePermissions/request',
  'userRole/fetchRolePermissions/success',
  'userRole/fetchRolePermissions/failure',
)<
  FetchRolePermissionsRequestPayload,
  FetchRolePermissionsSuccessPayload,
  undefined
>();

export type FetchAllPermissionsSuccessPayload = {
  data: PermissionItem[];
};

export const fetchAllPermissions = createAsyncAction(
  'userRole/fetchAllPermissions/request',
  'userRole/fetchAllPermissions/success',
  'userRole/fetchAllPermissions/failure',
)<void, FetchAllPermissionsSuccessPayload, undefined>();

export type AddRolePermissionsRequestPayload = {
  roleId: string;
  permissionIds: string[];
};

export type AddRolePermissionsSuccessPayload = {
  roleId: string;
  permissionIds: string[];
};

export const addRolePermissions = createAsyncAction(
  'userRole/addRolePermissions/request',
  'userRole/addRolePermissions/success',
  'userRole/addRolePermissions/failure',
)<
  AddRolePermissionsRequestPayload,
  AddRolePermissionsSuccessPayload,
  undefined
>();

export type RemoveRolePermissionsRequestPayload = {
  roleId: string;
  permissionIds: string[];
};

export type RemoveRolePermissionsSuccessPayload = {
  roleId: string;
  permissionIds: string[];
};

export const removeRolePermissions = createAsyncAction(
  'userRole/removeRolePermissions/request',
  'userRole/removeRolePermissions/success',
  'userRole/removeRolePermissions/failure',
)<
  RemoveRolePermissionsRequestPayload,
  RemoveRolePermissionsSuccessPayload,
  undefined
>();
